/* wk-welcome-popup.js -- WELCOME10 kayit popup'i (Wolf onayi 30.09.2026). Vanilla, defer, bagimliliksiz.
   Isaretleme: snippets/wk-welcome-popup.liquid (native <dialog>: top-layer => CLS yok, Esc + odak hapsi tarayicida).
   Tetik: 25 sn VEYA %50 scroll VEYA masaustu exit-intent (hangisi once). Sayfa acilisinda ACILMAZ.
   Frekans: basari => bir daha asla (wk_welcome_done) ; kapatma => 14 gun (wk_welcome_dismissed_at) ; oturum basina 1.
   Cookie bar (#bespoky-cookie-bar) gorunurken acilmaz, kapanmasini bekler. ?wk_welcome=preview => sadece test onizlemesi. */
(function () {
  'use strict';
  var d = document.getElementById('wk-welcome');
  if (!d || typeof d.showModal !== 'function') return;

  var K_DONE = 'wk_welcome_done', K_DISMISS = 'wk_welcome_dismissed_at', K_SESSION = 'wk_welcome_shown';
  var DAYS = 14, DELAY = 25000, SCROLL = 0.5, EXIT_ARM = 4000;
  var lastFocus = null, done = false, fired = false;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function track(ev) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: ev }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, {}); } catch (e) {}
  }

  var params = new URLSearchParams(window.location.search);
  var posted = params.get('customer_posted') === 'true' || !!d.querySelector('[data-wk-posted="success"]');
  var errored = !!d.querySelector('[data-wk-posted="error"]');
  var preview = params.get('wk_welcome') === 'preview' || params.get('wk_welcome') === 'preview-success';

  function panel(name) {
    var ps = d.querySelectorAll('[data-wk-panel]');
    for (var i = 0; i < ps.length; i++) ps[i].hidden = ps[i].getAttribute('data-wk-panel') !== name;
    d.setAttribute('aria-labelledby', name === 'success' ? 'wk-welcome-ok' : 'wk-welcome-title');
    if (name === 'success') d.removeAttribute('aria-describedby');
  }

  function open() {
    if (d.open) return;
    lastFocus = document.activeElement;
    try { d.showModal(); } catch (e) { return; }
    ssSet(K_SESSION, '1');
    var tgt = d.querySelector('[data-wk-panel="success"]:not([hidden]) #wk-welcome-ok') || d.querySelector('#wk-welcome-email');
    if (tgt) { try { tgt.focus({ preventScroll: true }); } catch (e) { tgt.focus(); } }
    track(done ? 'wk_welcome_success_view' : 'wk_welcome_view');
  }

  function close() { if (d.open) d.close(); }

  d.addEventListener('close', function () {
    if (!done && !preview) lsSet(K_DISMISS, String(Date.now()));
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  });
  // arka plana (backdrop) tik => kapat
  d.addEventListener('click', function (e) { if (e.target === d) close(); });
  var cl = d.querySelectorAll('[data-wk-close]');
  for (var i = 0; i < cl.length; i++) cl[i].addEventListener('click', close);

  var form = d.querySelector('form');
  if (form) form.addEventListener('submit', function () { track('wk_welcome_submit'); });

  var copyBtn = d.querySelector('[data-wk-copy]');
  var live = d.querySelector('[data-wk-live]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var code = d.getAttribute('data-code') || 'WELCOME10';
    var ok = function () {
      var t = copyBtn.getAttribute('data-copied') || 'Copied';
      if (!copyBtn.getAttribute('data-label')) copyBtn.setAttribute('data-label', copyBtn.textContent);
      copyBtn.textContent = t;
      if (live) live.textContent = t;
      setTimeout(function () { copyBtn.textContent = copyBtn.getAttribute('data-label'); }, 2500);
      track('wk_welcome_copy');
    };
    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      d.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      d.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, fallback);
    else fallback();
  });
  var apply = d.querySelector('[data-wk-apply]');
  if (apply) apply.href = apply.getAttribute('href') + '?redirect=' + encodeURIComponent(window.location.pathname);

  // 0) test onizlemesi, basari paneli (?wk_welcome=preview-success) -- hicbir kayit yazmaz
  if (params.get('wk_welcome') === 'preview-success') { panel('success'); setTimeout(open, 300); return; }
  // 1) basarili kayit donusu: kodu hemen goster, bir daha asla popup yok
  if (posted) {
    done = true;
    lsSet(K_DONE, '1');
    panel('success');
    open();
    track('wk_welcome_signup');
    return;
  }
  panel('form');
  // 2) form hatasi donusu: formu hata mesajiyla yeniden ac
  if (errored) { open(); return; }
  // 3) test onizlemesi (?wk_welcome=preview) -- frekans kaydi yazmaz
  if (preview) { setTimeout(open, 300); return; }

  if (lsGet(K_DONE) === '1') return;
  var t0 = parseInt(lsGet(K_DISMISS) || '0', 10);
  if (t0 && (Date.now() - t0) < DAYS * 864e5) return;
  if (ssGet(K_SESSION) === '1') return;
  var p = window.location.pathname.toLowerCase();
  if (/\/(cart|checkout|account|policies)(\/|$)|\/pages\/contact/.test(p)) return;

  function busy() {
    var a = document.activeElement;
    return a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !d.contains(a);
  }
  function whenClear(cb) {
    var tries = 0;
    (function wait() {
      var bar = document.getElementById('bespoky-cookie-bar');
      var otherModal = document.querySelector('dialog[open]:not(#wk-welcome)');
      if ((bar && document.contains(bar)) || otherModal || busy()) {
        if (++tries > 600) return; // ~10 dk sonra vazgec
        return setTimeout(wait, 1000);
      }
      open();
    })();
  }
  function fire(why) {
    if (fired) return;
    fired = true;
    d.setAttribute('data-wk-trigger', why || '');
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onOut);
    whenClear(open);
  }
  var timer = setTimeout(function () { fire('time'); }, DELAY);
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h >= SCROLL) fire('scroll');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  var armed = false;
  setTimeout(function () { armed = true; }, EXIT_ARM);
  var moved = 0; // gercek fare hareketi olmadan exit-intent sayilmaz
  document.addEventListener('mousemove', function () { moved++; }, { passive: true });
  function onOut(e) { if (armed && moved > 3 && !e.relatedTarget && e.clientY <= 0) fire('exit'); }
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', onOut);
  }
})();
